import styled from 'styled-components';
import { em } from 'polished';
import { mediaQuery } from '../util/style';
import { appTheme } from '../../../theme';

const FormButtons = styled.div`
  display: flex;
  margin-bottom: ${em(appTheme.spacing.large)};
  margin-top: ${em(appTheme.spacing.large)};

  ${mediaQuery.xsmall`
    align-items: center;
    flex-direction: column;
  `};
`;

export default FormButtons;



// WEBPACK FOOTER //
// ./src/modules/common/form/FormButtons.js